import React from 'react'
import { ArrowRight, Clock, MapPin, Users, Star, Ship } from 'lucide-react'

export default function CruiseCallout({ cruise }) {
  if (!cruise?.permalink) return null

  const meta = [
    cruise.duration  && { icon: <Clock  size={12} strokeWidth={1.5} />, text: cruise.duration },
    cruise.departure && { icon: <MapPin size={12} strokeWidth={1.5} />, text: cruise.departure },
    cruise.guests    && { icon: <Users  size={12} strokeWidth={1.5} />, text: cruise.guests },
    cruise.rating    && { icon: <Star   size={12} strokeWidth={1.5} />, text: `${cruise.rating} rating` },
  ].filter(Boolean)

  return (
    <section className="si-section">
      <div className="si-callout__label">
        <Ship size={12} strokeWidth={1.5} />
        Part of this cruise
      </div>
      <div className="si-callout__inner">
        {cruise.thumb && (
          <a href={cruise.permalink} className="si-callout__img">
            <img src={cruise.thumb} alt={cruise.title} />
          </a>
        )}
        <div className="si-callout__body">
          <div className="si-callout__heading">
            <h3 className="si-callout__title">
              <a href={cruise.permalink}>{cruise.title}</a>
            </h3>
            {cruise.tagline && (
              <span className="si-callout__tagline">{cruise.tagline}</span>
            )}
          </div>
          {meta.length > 0 && (
            <div className="si-callout__meta">
              {meta.map((m, i) => (
                <span key={i} className="si-callout__meta-item">
                  {m.icon}{m.text}
                </span>
              ))}
            </div>
          )}
          {cruise.excerpt && (
            <p className="si-callout__excerpt">{cruise.excerpt}</p>
          )}
          <a href={cruise.permalink} className="si-callout__cta">
            View cruise details
            <ArrowRight size={14} strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </section>
  )
}
